import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Text } from '../../components/Text';
import { LoadingBar } from '../../components/util/LoadingBar';
import { DynamicWrapper } from '../../components/util/DynamicWrapper';
import { IntRangeSelect } from '../../components/controls/IntRangeSelect';
import { backOnboarding, continueOnboarding, pathAware } from '../../actions/onboardingActions';

const StyledAnswerRow = styled.div`
  width: 80%;
`;

class Ages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      primaryAge: props.qna_hash.primaryAge ? props.qna_hash.primaryAge.answer : null,
      partnerAge: props.qna_hash.partnerAge ? props.qna_hash.partnerAge.answer : null,
    };
  }

  componentDidMount() {
    this.props.pathAware('primaryAge');
  }

  componentWillReceiveProps(props) {
    if (props.qna_hash.primaryAge) {
      let mergeState = {
        primaryAge: props.qna_hash.primaryAge.answer,
      };
      if (props.qna_hash.hasPartner.answer) {
        mergeState.partnerAge = props.qna_hash.partnerAge.answer;
      }
      this.setState(mergeState);
    }
  }

  _onContinue = () => {
    const { onContinue, qna_hash, qna_stack } = this.props;

    let frame = {
      primaryAge: {
        question: 'How old are you?',
        answer: this.state.primaryAge,
      },
    };

    if (qna_hash.hasPartner.answer) {
      frame.partnerAge = {
        question: 'How old is your spouse?',
        answer: this.state.partnerAge,
      };
    }

    this.props.continueOnboarding(qna_stack, qna_hash, frame).then(onContinue);
  };

  _canContinue = () => {
    if (this.props.qna_hash.hasPartner.answer) {
      return this.state.primaryAge !== null && this.state.partnerAge !== null;
    } else {
      return this.state.primaryAge !== null;
    }
  };

  _onBack = () => {
    this.props.backOnboarding(this.props.qna_stack).then(() => this.props.onBack());
  };

  onChange = (evt, field) => {
    this.setState({ [field]: evt.target.value });
  };

  render() {
    const { qna_hash, wrapper } = this.props;

    if (!qna_hash.hasPartner) {
      return <LoadingBar />;
    }

    return (
      <DynamicWrapper
        style={{ width: '100%' }}
        wrapper={wrapper}
        onContinue={this._onContinue}
        onBack={this._onBack}
        canContinue={this._canContinue()}
      >
        <div style={{ width: '90%', display: 'flex', justifyContent: 'center' }}>
          <Text use="headline6">How old are you?</Text>
        </div>
        <StyledAnswerRow>
          <IntRangeSelect
            id="primaryAge"
            value={this.state.primaryAge}
            onChange={evt => this.onChange(evt, 'primaryAge')}
            label="Your Age"
            spec={{
              field_type: 'integer',
              min: 18,
              max: 85,
              focus_option: 55,
            }}
          />
        </StyledAnswerRow>

        {qna_hash.hasPartner.answer && (
          <StyledAnswerRow className="mt-3">
            <IntRangeSelect
              id="partnerAge"
              value={this.state.partnerAge}
              onChange={evt => this.onChange(evt, 'partnerAge')}
              label="Your Spouse's Age"
              spec={{
                field_type: 'integer',
                min: 18,
                max: 85,
                focus_option: 55,
              }}
            />
          </StyledAnswerRow>
        )}
      </DynamicWrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    qna_hash: state.onboarding.qna_hash,
    qna_stack: state.onboarding.qna_stack,
  };
}

export default connect(mapStateToProps, { backOnboarding, continueOnboarding, pathAware })(Ages);
